module.exports = __webpack_public_path__ + "static/img/tapJin.faa44453.png";